import "./App.css";
import AppRoutes from "./routes";
import { Provider } from "react-redux";
import { store } from "./store";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Auth from "./components/auth";
import ConfigSWR from "./services/swr";
import "./translations/translations"

function App() {
  return (
    <Provider store={store}>
      <ConfigSWR>
        <Auth>
        <AppRoutes />
        </Auth>
        <ToastContainer />
      </ConfigSWR>
    </Provider>
  );
}

export default App;

// glpat-eTEnZ_d7Fs4c8iUy1WNU